import { useAtom } from "jotai";
import { useEffect } from "react";
import { useLocation } from "react-router";
import useNavigateWEB from "~/shared/hooks/use-navigate/useNavigateWEB";
import { ppmAtom } from "~/utils/jotai";

export const taRadgivningPaNyttAtom = ppmAtom<boolean>("taRadgivningPaNyttAtom", false);

function useTaRadgivningPaNytt(lenke: string) {
	const [taRadgivningPaNytt, setTaRadgivningPaNytt] = useAtom(taRadgivningPaNyttAtom);
	const location = useLocation();
	const navigate = useNavigateWEB();

	useEffect(() => {
		// Håndterer ta rådgivning på nytt ved å gå tilbake til steget hver flyt spesifiserer
		// dermed hvis kunden trykker tilbake så vil de bli send til intro siden.
		// Liker ikke dette, hadde kanskje vært bedre å bare å bare navigere til spesifisert
		// steg og hvis kunden trykker tilbake så kommer de bare til bake til anbefalingssiden.
		if (taRadgivningPaNytt && lenke !== location.pathname) {
			navigate(-1);
		} else if (taRadgivningPaNytt && lenke === location.pathname) {
			setTaRadgivningPaNytt(false);
		}
	}, [taRadgivningPaNytt, location.pathname]);
}
export default useTaRadgivningPaNytt;
